import * as angular from 'angular';
import 'angular-ui-router';
import 'angular-cookies';
import 'ng-toast';
import AuthenticationService from './AuthenticationService';
import AuthenticationInterceptor from './AuthenticationInterceptor';
import LoginController_Old from './old/LoginController';
import LoginView_Old from './old/LoginView.html';
import LoginController from './LoginController';
import LoginView from './LoginView.html';
import LogoutController_Old from './old/LogoutController';
import LogoutController from './LogoutController';
import LogoutView from './LogoutView.html';
import { isLocalhost } from 'data/http';
import { AccountFeatures } from 'modules/account/AccountFeatures';
export const logoutStateName = 'logout';
//
export default angular
    .module('login', ['ui.router', 'ngCookies', 'ngToast'])
    .service('AuthenticationService', AuthenticationService)
    .service('AuthenticationInterceptor', AuthenticationInterceptor)
    .config(['$httpProvider', '$stateProvider', '$cookiesProvider', function ($httpProvider, $stateProvider, $cookiesProvider) {
        $cookiesProvider.defaults.secure = !isLocalhost(window.location.href);
        $httpProvider.interceptors.push('AuthenticationInterceptor');
        $stateProvider
            .state('anon.login', {
            url: '/login?sso&sig&provider',
            controllerAs: '$ctrl',
            params: {
                currentState: undefined,
                currentParams: undefined,
                redirectUrl: undefined,
                area: 'user-login',
            },
            resolve: {
                isBlipAccountEnabled() {
                    try {
                        return new Promise(async (r) => {
                            r(AccountFeatures.isBlipAccountEnabled());
                        });
                    }
                    catch (e) {
                        console.error(e);
                    }
                },
            },
            templateProvider: ['isBlipAccountEnabled', function (isBlipAccountEnabled) {
                    return isBlipAccountEnabled ? LoginView : LoginView_Old;
                }],
            controllerProvider: ['isBlipAccountEnabled', function (isBlipAccountEnabled) {
                    return isBlipAccountEnabled
                        ? LoginController
                        : LoginController_Old;
                }],
        })
            .state(logoutStateName, {
            url: '/logout',
            template: LogoutView,
            params: {
                tenantId: undefined,
                shortName: undefined,
            },
            resolve: {
                isBlipAccountEnabled() {
                    try {
                        return new Promise(async (r) => {
                            r(AccountFeatures.isBlipAccountEnabled());
                        });
                    }
                    catch (e) {
                        console.error(e);
                    }
                },
            },
            controllerProvider: ['isBlipAccountEnabled', function (isBlipAccountEnabled) {
                    return isBlipAccountEnabled
                        ? LogoutController
                        : LogoutController_Old;
                }],
        });
    }])
    .run(['$rootScope', '$state', '$location', 'ngToast', 'AuthenticationService', function ($rootScope, $state, $location, ngToast, AuthenticationService) {
        $rootScope.$on('$stateChangeStart', function (e, toState) {
            const redirectToUrl = encodeURI($location.search().redirectUrl);
            if (toState.name == logoutStateName &&
                redirectToUrl &&
                !AuthenticationService.isAuthenticated()) {
                window.location.href = redirectToUrl;
            }
        });
    }]).name;
